<template>
    <v-alert
        v-if="shouldShowAlert"
        :type="alertType"
        prominent
        dense
        outlined
        text
        class="mb-4 mt-2"
    >
        <v-row align="center">
            <v-col class="grow">
                <strong>{{ alertMessage }}</strong>
            </v-col>
        </v-row>
    </v-alert>
</template>

<script>
export default {
    name: 'CancellationRecurrenceAlert',
    props: {
        booking: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            recurrenceData: {
                count: 0,
                reason: null,
                days: 180,
                has_recurrence: false,
                alert_needed: false
            },
            loading: false
        };
    },
    computed: {
        shouldShowAlert() {
            return this.booking &&
                   this.booking.status === 'canceled' &&
                   this.recurrenceData.has_recurrence &&
                   this.recurrenceData.alert_needed;
        },
        alertType() {
            return this.recurrenceData.count > 2 ? 'error' : 'warning';
        },
        alertMessage() {
            const count = this.recurrenceData.count;
            const reason = this.recurrenceData.reason;
            const days = this.recurrenceData.days;

            return `Pela ${count}ª vez em ${days} dias o hoteleiro preencheu esse mesmo motivo em uma recusa de reserva. O time do Sourcing precisa entrar em contato com este cliente.`;
        }
    },
    watch: {
        booking: {
            immediate: true,
            handler(newBooking) {
                if (newBooking && newBooking.status === 'canceled' && newBooking.canceled_reason) {
                    this.fetchRecurrenceData();
                }
            }
        }
    },
    methods: {
        async fetchRecurrenceData() {
            if (!this.booking || !this.booking.id) {
                return;
            }

            this.loading = true;
            try {
                const response = await axios.get(`/api/booking/${this.booking.id}/cancellation-recurrence`);
                if (response.data.success && response.data.data) {
                    this.recurrenceData = response.data.data;
                }
            } catch (error) {
                console.error('Erro ao buscar dados de recorrência:', error);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>
.v-alert {
    font-size: 14px;
}
</style>
